import { render } from "./Utrc.vue?vue&type=template&id=47138b17"
import script from "./Utrc.vue?vue&type=script&lang=js"
export * from "./Utrc.vue?vue&type=script&lang=js"

import "./Utrc.vue?vue&type=style&index=0&id=47138b17&lang=css"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\记录\\2508幸运28\\xingyun_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__